<template>
	<RescheduleRequestsList title="sideMenu.acceptedRequests" status="2" />
</template>

<script>
import RescheduleRequestsList from "./RescheduleRequestsList.vue";

export default {
	name: "RefusedRequests",
	components: { RescheduleRequestsList },
};
</script>
